import * as d3 from 'd3';

export function prepareStrokePoint<T extends { color?: string }>(selection: d3.Selection<T>): d3.Selection<T> {
    return selection.style('stroke-width', 2);
}

export function strokePoint<T extends { color?: string }>(sel: d3.Selection<T>): d3.Selection<T> {
    return sel.style('stroke', d => d3.rgb(d.color).darker(1.5).toString());
}

export function unstrokePoint<T extends { color?: string }>(sel: d3.Selection<T>): d3.Selection<T> {
    return sel.style('stroke', null);
}

// TODO refactoring does not work,
//  get back to old version and extract style to be able to compute them with other independant methods
export function highlightOnHover<T extends { color?: string }>(
    selection: d3.Selection<T>,
    callbacks?: { [event: string]: (d: T, selection: d3.Selection<T>) => void }
) {
    return prepareStrokePoint(selection)
        .on('mouseenter', function (d) {
            const sel = strokePoint(d3.select(this));
            if (callbacks && callbacks['mouseenter']) {
                callbacks['mouseenter'](d, sel);
            }
        })
        .on('mouseout', function (d) {
            const sel = unstrokePoint(d3.select(this));
            //const sel = d3.select(this).style('stroke', null);
            if (callbacks && callbacks['mouseout']) {
                callbacks['mouseout'](d, sel);
            }
        });
}
